import { Paths } from "@routes/paths";
import { type RouteDefinition } from "@routes/route-definition";
import { AppBuildNumberScreen } from "./app-build-number.screen";
import { hasMobileApp } from "../../environment";

export const AppBuildNumberRoutes: RouteDefinition[] = hasMobileApp
	? [
			{
				path: Paths.appBuildNumber.path,
				element: <AppBuildNumberScreen />,
				requiredPermissions: "onlyOwnerOfRoot",
			},
	  ]
	: [];
